export default __webpack_public_path__ + "static/media/20_desktop.c97e0ae9.jpg";